<script>
import Form from '@/Pages/Public/MembershipApplication/Form'
import AppLayoutNoAuth from '@/Layout/AppLayoutNoAuth'
export default {
	layout: AppLayoutNoAuth
}
</script>

<script setup>

const props = defineProps({
	membershipTiers: {
		type: Array,
		required: true,
	},
	paymentFrequencies: {
		type: Array,
		required: true,
	},
	fields: {
		required: true
	}
})

</script>

<template>
	<Form
		:fields="fields"
		:membership-tiers="membershipTiers"
		:payment-frequencies="paymentFrequencies"
	/>
</template>